import Vue from 'vue';
import Vuex from 'vuex';
import {menuList, menuGroup} from '@/router/routes.js'
import fun from '@/assets/script/function.js'

Vue.use(Vuex);

const COMMON_APPROVE_STATE = [{
	name: '待监理审批',
	value: 1,
	color: '#1492FF'
}, {
	name: '待业主审批',
	value: 2,
	color: '#1492FF'
}, {
	name: '已完成',
	value: 3,
	color: '#00B575'
}, {
	name: '驳回',
	value: 4,
	color: '#E63633'
}];

function power(state, role) {
	return !role || (state.userInfo.user_type && role.split(',').includes(state.userInfo.user_type.toString()));
}

function stateSerialize(data) {
	let json = {};
	data.forEach(item => {
		if (typeof item.value == 'object') {
			item.value.forEach(i => {
				json[i] = item;
			});
		} else {
			json[item.value] = item;
		}
	});
	return json;
}

let app = new Vue();
export default new Vuex.Store({
	state: {
		elder: false,
		networkError: false,
		userInfo: {},  // 用户类型（3：保险公司，4：业主单位；5：招标代理；6：协助理赔，7：企业角色，8：监理角色；）
		messageTotal: 0,
		
		// 行业列表
		hangyeList: [{
			name: '交通',
			value: '交通'
		}, {
			name: '水利',
			value: '水利'
		}, {
			name: '市政',
			value: '市政'
		}, {
			name: '住建',
			value: '住建'
		}],
		
		// 发票类型
		invoiceType: [{
			name: '普通发票',
			value: 1
		}, {
			name: '增值税专用发票',
			value: 2
		}, {
			name: '不要发票',
			value: 3
		}],
		
		// 项目状态
		projectStateList: [{
			name: '驳回',
			value: 1,
			color: '#E63633'
		}, {
			name: '待确认',
			value: 2,
			color: '#1492FF'
		}, {
			name: '待设置中标企业',
			value: 3,
			color: '#1492FF'
		}, {
			name: '业主审批中',
			value: [31, 32],
			color: '#1492FF'
		}, {
			name: '创建成功',
			value: 4,
			color: '#00B575'
		}],
		
		// 合同状态
		contractStateList: [{
			name: '待业主签署',
			value: [0, 1],
			color: '#1492FF'
		}, {
			name: '待企业签署',
			value: 2,
			color: '#1492FF'
		}, {
			name: '签署完成',
			value: 3,
			color: '#00B575'
		}, {
			name: '驳回',
			value: 4,
			color: '#E63633'
		}],
		
		// 保险状态
		insuranceStateList: [{
			name: '未购买',
			value: 0,
			color: '#E63633',
			icon: '\ue607'
		}, {
			name: '草稿',
			value: 1,
			color: '#1492FF',
			icon: '\ue6aa'
		}, {
			name: '待付款',
			value: 2,
			color: '#1492FF',
			icon: '\ue6aa'
		}, {
			name: '待审批',
			value: 3,
			color: '#1492FF',
			icon: '\ue6aa'
		}, {
			name: '已完成',
			value: 4,
			color: '#00B575',
			icon: '\ue65e'
		}, {
			name: '驳回',
			value: 5,
			color: '#E63633',
			icon: '\ue607'
		}],
		
		// 人员变更状态
		personStateList: COMMON_APPROVE_STATE,
		
		// 开工令状态
		proceedStateList: COMMON_APPROVE_STATE,
		
		// 台账状态
		ledgerStateList: [{
			name: '待监理审批',
			value: 1,
			color: '#1492FF'
		}, {
			name: '待业主审批',
			value: 2,
			color: '#1492FF'
		}, {
			name: '待业主审批',
			value: 21,
			color: '#1492FF'
		}, {
			name: '已完成',
			value: 3,
			color: '#00B575'
		}, {
			name: '驳回',
			value: 4,
			color: '#E63633'
		}],
		
		// 理赔状态
		claimStateList: [{
			name: '待审批',
			value: 1,
			color: '#1492FF'
		}, {
			name: '受理中',
			value: 2,
			color: '#1492FF'
		}, {
			name: '待确认',
			value: 3,
			color: '#1492FF'
		}, {
			name: '已完成',
			value: 4,
			color: '#00B575'
		}, {
			name: '驳回',
			value: 5,
			color: '#E63633'
		}],
		
		// 协助理赔状态
		assistClaimStateList: [{
			name: '无需确认',
			value: 0,
			color: '#00B575'
		}, {
			name: '待确认',
			value: 1,
			color: '#1492FF'
		}, {
			name: '已确认',
			value: 2,
			color: '#00B575'
		}, {
			name: '不接受',
			value: 3,
			color: '#E63633'
		}]
	},
	
	getters: {
		power(state) {
			return role => {
				return power(state, role);
			}
		},
		
		private() {
			return (str, type) => {
				if (!str) return '';
				
				switch(type) {
				case 'phone':
					var arr = str.split('');
					arr.splice(3, 4, '****');
					return arr.join('');
					
				case 'name':
					return '*' + str.substring(1);
					
				case 'idcard':
					return str[0] + '*****************' + str[str.length - 1];
					
				default:
					if (str.length < 3) {
						return '*' + str.substring(1);
					}
					var length = Math.floor(str.length / 3);
					return str.substring(0, length) + (function(n) {
						let s = '';
						for (let i = 0; i < n; i++) {
							s += '*';
						}
						return s;
					})(str.length - (2 * length)) + str.substring(str.length - length);
				}
			}
		},
		
		menuList(state) {
			var list = [];
			menuList.forEach(item => {
				if (!power(state, item.meta.role)) {
					return;
				}
				
				let menu = menuGroup[item.meta.menu];
				
				if (menu.name) {
					let group = list.find(item => {
						return item.name == menu.name
					});
					
					if (!group) {
						group = {
							name: menu.name,
							icon: menu.icon,
							path: '/transact/' + item.path,
							children: [],
							role: ''
						}
						
						list.push(group);
					}
					
					group.children.push({
						name: item.meta.name || item.children[0].name,
						path: '/transact/' + item.path,
						role: item.meta.role
					});
					if (item.meta.role) {
						group.role += (group.role ? ',' : '') + item.meta.role;
					}
				} else {
					list.push({
						name: item.meta.name,
						icon: menu.icon,
						path: '/transact/' + item.path,
						role: item.meta.role
					});
				}
			});
			
			return list;
		},
		
		invoiceTypeName(state) {
			return stateSerialize(state.invoiceType);
		},
		
		projectState(state) {
			return stateSerialize(state.projectStateList);
		},
		
		contractState(state) {
			return stateSerialize(state.contractStateList);
		},
		
		insuranceState(state) {
			return stateSerialize(state.insuranceStateList);
		},
		
		personState(state) {
			return stateSerialize(state.personStateList);
		},
		
		proceedState(state) {
			return stateSerialize(state.proceedStateList);
		},
		
		ledgerState(state) {
			return stateSerialize(state.ledgerStateList);
		},
		
		claimState(state) {
			return stateSerialize(state.claimStateList);
		},
		
		assistClaimState(state) {
			return stateSerialize(state.assistClaimStateList);
		}
	},
	
	mutations: {
		// 设置老年模式
		setElder(state, data) {
			state.elder = !!data;
		},
		
		setNetworkError(state, data) {
			state.networkError = data;
		},
		
		// 设置用户信息
		setUserInfo(state, data) {
			if (!data.id) {
				data.id = 0;
			}
			state.userInfo = data;
		},
		
		// 设置未读消息数
		setMessageTotal(state, data) {
			state.messageTotal = data;
		}
	},

	actions: {
		updateUserInfo(store, callback) {
			if (!fun.getCookie('session_id')) {
				store.commit('setUserInfo', {});
				callback && callback();
				return;
			}
			app.request({
				url: '/user/cache',
				success: data => {
					store.commit('setUserInfo', data);
				},
				fail: () => {
					store.commit('setUserInfo', {});
					return false;
				},
				complete: callback
			});
		},
		
		updateMessageTotal(store, loop = true) {
			if (!fun.getCookie('session_id')) return;
			app.request({
				url: '/sysnotice/unCount',
				success: data => {
					store.commit('setMessageTotal', data);
					
					if (loop) {
						setTimeout(() => {
							store.dispatch('updateMessageTotal');
						}, 5000);
					}
				}
			});
		}
	}
});
